import { FC } from 'react';
import cx from 'classnames';
import { transitionAnimationClassNames } from '../../../../utils/transitionAnimationClassNames';

type TCancelButtonProps = {
  onClick?: () => void;
};

const DiscardCommentButton: FC<TCancelButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    type="button"
    className={cx(
      'absolute bottom-2 right-24 px-3 rounded-md border text-gray-700 bg-white-100 hover:text-white-100 hover:border-orange-500 hover:bg-orange-500 border-gray-700 capitalize',
      transitionAnimationClassNames,
    )}
  >
    Cancel
  </button>
);

export default DiscardCommentButton;
